import { constants } from "./constants";
import MapTemplate from "../../template";

export default function JMRVMap() {
    return <MapTemplate constants={constants} />;
}
